import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    const tempElement = document.createElement('div');
    tempElement.innerHTML = value;
    return tempElement.textContent || tempElement.innerText || '';
  }
}
